import React from "react";
import churchPhoto from "../assets/img/church.jpg";
import { Link } from "react-router";

export default function AboutChurch() {
  const milestones = [
    { year: "1840", text: "Fr. Bertrand SJ purchased the sacred land to settle 30 Christian sailor families." },
    { year: "1841", text: "Fr. Garnier SJ built the initial chapel, inaugurating the parish." },
    { year: "1916", text: "The majestic present cathedral edifice was designed and constructed." },
    { year: "1938", text: "Madurai Diocese established; elevated to Pro-Cathedral with the Bishop's Throne." },
    { year: "1969", text: "Bestowed full Cathedral status, seat of the Roman Catholic Archdiocese of Madurai." }
  ];

  const associations = [
    "Society of St. Vincent de Paul",
    "Family Welfare Team",
    "Bible Society",
    "St. Mary's Youth Movement",
    "Legion of Mary",
    "St. Mary's Altar Servers"
  ];

  return (
    <section id="history" className="history-section py-5">
      <div className="container py-4">
        {/* Section Header */}
        <div className="section-heading-wrapper text-center mb-5">
          <div className="eyebrow-badge">
            <i className="fas fa-landmark"></i>
            <span>Centuries of Faith & Heritage</span>
          </div>
          <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", color: "var(--cathedral-navy)" }}>
            History of St. Mary's Cathedral
          </h2>
          <div className="cross-ornament">
            <i className="fas fa-cross"></i>
          </div>
          <p style={{ maxWidth: "700px", margin: "0 auto", color: "var(--cathedral-text-secondary)" }}>
            More than 180 years of sacred tradition, pastoral dedication, and vibrant community life in Madurai.
          </p>
        </div>

        <div className="row g-5 align-items-center">
          {/* Historical Narrative */}
          <div className="col-lg-7">
            <div className="history-card">
              <span className="badge mb-3" style={{ background: "#f5eedb", color: "#997327", border: "1px solid #ebdcb7", fontSize: "0.82rem", letterSpacing: "1px", textTransform: "uppercase", padding: "6px 14px" }}>
                Mother Church of the Archdiocese
              </span>
              <h3 style={{ fontFamily: "'Playfair Display', Georgia, serif", color: "var(--cathedral-navy-dark)", fontSize: "1.85rem", marginBottom: "18px" }}>
                From Humble Chapel to Majestic Cathedral
              </h3>

              <p style={{ textAlign: "justify", lineHeight: "1.8", color: "var(--cathedral-text-secondary)", marginBottom: "16px" }}>
                Built in 1841, St. Mary's Cathedral has an inspiring history spanning over 180 years. Initially built as a small chapel by <strong>Fr. Garnier</strong> over a piece of land acquired in 1840 by <strong>Fr. Bertrand SJ</strong>, it provided spiritual refuge for around 30 sailor families settled here from W. Pudupatti.
              </p>

              <p style={{ textAlign: "justify", lineHeight: "1.8", color: "var(--cathedral-text-secondary)", marginBottom: "20px" }}>
                As the Catholic community grew rapidly, the chapel was expanded through the devoted labors of <strong>Fr. Hibolite SJ</strong> and <strong>Br. Lemothe SJ</strong>. The present cathedral edifice was erected in 1916. In 1938, upon the erection of the Madurai Diocese, St. Mary's was bestowed with Pro-Cathedral status and housed the Bishop’s throne. In 1969, the church was consecrated as a full Cathedral, standing today as the mother church and seat of the Madurai Roman Catholic Archdiocese.
              </p>

              {/* Parish Associations */}
              <div className="pt-3 border-top" style={{ borderColor: "#ede6d8" }}>
                <h6 style={{ color: "var(--cathedral-navy)", fontSize: "0.95rem", fontWeight: 700, marginBottom: "12px" }}>
                  <i className="fas fa-hands-helping text-secondary me-2"></i> Active Parish Ministries & Associations:
                </h6>
                <div className="d-flex flex-wrap gap-2 mb-4">
                  {associations.map((assoc, idx) => (
                    <span
                      key={idx}
                      className="badge"
                      style={{
                        backgroundColor: "#f7f5ed",
                        color: "#2c3e50",
                        border: "1px solid #e2d9c4",
                        padding: "6px 12px",
                        fontSize: "0.82rem",
                        fontWeight: 500
                      }}
                    >
                      <i className="fas fa-check-circle text-secondary me-1" style={{ fontSize: "0.75rem" }}></i>
                      {assoc}
                    </span>
                  ))}
                </div>

                <div className="d-flex flex-wrap gap-3">
                  <Link to="/parish-admin" className="btn-cathedral-primary" style={{ fontSize: "0.88rem", padding: "10px 22px" }}>
                    <i className="fas fa-users-cog me-2"></i> Parish Administration
                  </Link>
                  <Link to="/substations" className="btn-cathedral-outline" style={{ fontSize: "0.88rem", padding: "10px 22px" }}>
                    <i className="fas fa-church me-2"></i> Explore Substations
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Cathedral Photography & Timeline */}
          <div className="col-lg-5">
            <div className="history-image-frame mb-4">
              <img
                src={churchPhoto}
                className="img-fluid w-100"
                alt="St. Mary's Cathedral Madurai Historic Edifice"
                style={{ maxHeight: "380px", objectFit: "cover" }}
              />
              <div className="history-badge">
                <i className="fas fa-shield-alt text-secondary me-2"></i>
                Consecrated Cathedral • Est. 1841
              </div>
            </div>

            {/* Historical Milestones Mini Timeline */}
            <div className="p-4 rounded-3" style={{ background: "#ffffff", border: "1px solid #ebdcb7", boxShadow: "0 4px 16px rgba(27, 58, 107, 0.05)" }}>
              <h5 style={{ fontFamily: "'Playfair Display', serif", color: "var(--cathedral-navy)", fontSize: "1.15rem", marginBottom: "16px" }}>
                <i className="fas fa-hourglass-half text-secondary me-2"></i> Historical Milestones
              </h5>
              <div className="d-flex flex-column gap-3">
                {milestones.map((m, i) => (
                  <div key={i} className="d-flex align-items-start gap-3">
                    <span
                      style={{
                        background: "var(--cathedral-navy)",
                        color: "#ffffff",
                        padding: "3px 10px",
                        borderRadius: "4px",
                        fontSize: "0.78rem",
                        fontWeight: 700,
                        fontFamily: "'Cinzel', serif",
                        minWidth: "54px",
                        textAlign: "center"
                      }}
                    >
                      {m.year}
                    </span>
                    <span style={{ fontSize: "0.88rem", color: "var(--cathedral-text-secondary)", lineHeight: 1.5 }}>
                      {m.text}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
